import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { CmsService } from '../../../core/services/cms.service';
import { CmsContent } from '../../../shared/models/cms';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import * as _ from 'lodash';
import { ProductsService } from '../../products/products.service';
import { ProductUtilService } from '../../products/product-util.service';
import { UserService } from '../../../core/services/user.service';
import { CacheConstant } from '../../../core/constants/app.constant';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Product } from '../../../shared/models/product';
import { AppUtilService } from '../../../core/utils/app-util.service';
import { AppConfigService } from '../../../core/services/init/app-config.service';
import { GoogleAnalyticsService } from '../../../core/services/google-analytics.service';

@Component({
    selector: 'sale-popup',
    templateUrl: './sale-popup.component.html',
    styleUrls: ['./sale-popup.component.scss']
})
export class SalePopupComponent implements OnInit {

    salePopupData: CmsContent;
    private timeout = null;
    readonly config = {
        loading: true,
    };
    disablePromotion: boolean = false;
    envProperties = this.cache.get(CacheConstant.Env_Properties);
    websiteName = this.envProperties.theme;
    orderColumns = [];
    itemsData: MatTableDataSource<any> = new MatTableDataSource();
    isAddToCartClicked: boolean = false;
    productList: Product[] = new Array<Product>();
    showCaseQtyAlert: boolean = false;
    showQtyAlert: boolean;
    showItemQtyAlert = [];
    itemList = [];
    contentLoaded: boolean;

    constructor(
        private dialog: MatDialog,
        public dialogRef: MatDialogRef<SalePopupComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private cache: AppCacheService,
        private cmsService: CmsService,
        private productService: ProductsService,
        private userService: UserService,
        private productUtil: ProductUtilService,
        private gAnalytics: GoogleAnalyticsService,  private appConfig: AppConfigService) { }

    ngOnInit() {
        this.salePopupData = this.data.cmsContent;
        this.itemList = this.data.itemList;
        //   this.init();
        this.itemsData = new MatTableDataSource(this.itemList);
        this.contentLoaded = true;

        if (this.websiteName === 'Parmed') {
            this.orderColumns = ['item', 'description', 'size', 'form', 'price', 'qty', 'addToCart'];
        }
    }

    //   private init() {
    //     this.timeout = setTimeout(() => {
    //       this.config.loading = false;
    //       clearTimeout(this.timeout);
    //     }, 1000);
    //   }

    onProductClick(item: any) {
        window.open('/product/details/' + item.itemId);
    }

    onImageLoadError() {
        this.config.loading = false;
        this.salePopupData.contentStructureJson.mediaUrl = "NO_IMAGE_URL";
    }

    cmsMediaClick(cmsContentLinkObj: any) {
        if (!_.isEmpty(cmsContentLinkObj)) {
            if (this.appConfig.gTrackingId) {
                this.gAnalytics.promotionPopClick(this.salePopupData?.contentStructureJson.title);
              }
            this.cmsService.redirectBasedOnLinkType(cmsContentLinkObj);
        }
    }

    closeDialog() {
        if (this.disablePromotion) {
            this.userService.saveDisablePromotionPopUp().subscribe((response: any) => {
                if(!response){
                    AppUtilService.message.success('Promotion removed for this week.');
                } 
            });
        }
        this.dialogRef.close('close');
    }

    checkProductBeforeAddToCart(item: any) {
   
        this.isAddToCartClicked = true;
        if (this.onItemQuantityChange(item)) {
            return;
        }
        this.onAddToCartClick(item);
    }


    onAddToCartClick(item: any) {
        this.productList = [];
        this.productList.push(item);
        if (this.isExcludedAllocatedQty(item) || this.isExcludedUnitPrice(item) || this.getOutofStockProducts(item)) {
            this.productUtil.getInvalidCartProducts(this.productList);
            AppUtilService.message.error("Product not added to the cart.");
        }
        else {
            this.productUtil.addToCart(this.productList, null, 'Search Results').subscribe(result => {
                if (result.hasError) {
                    AppUtilService.message.error("Product not added to the cart.");
                }
                else {
                    if (this.appConfig.gTrackingId) {
                        this.gAnalytics.promotionPopSale(item, this.salePopupData?.contentStructureJson.title);
                      }
                    AppUtilService.message.success('Product added to the cart.');
                }
            });
        }
    }

    isExcludedAllocatedQty(product: any) {
        return product.allocatedQuantity === undefined || product.allocatedQuantity === -2 ||
            product.allocatedQuantity === -3;
    }

    isExcludedUnitPrice(product: any) {
        return product.currentPrice === undefined || product.currentPrice === null || product.currentPrice <= 0;
    }

    getOutofStockProducts(product) {
        return product.allocatedQuantity === -1 || product.allocatedQuantity === 0;
    }

    onItemQuantityChange(item: any) {
        if (item.cartQuantity > 0 && !isNaN(item.cartQuantity)) {
            this.showQtyAlert = false;
            this.showCaseQtyAlert = false;
            this.showItemQtyAlert[item.itemId] = false;
            return false;
        }
        else if (this.isAddToCartClicked === true) {

            this.isAddToCartClicked = false;
            this.showQtyAlert = true;
            this.showItemQtyAlert[item.itemId] = true;
            return true;

        }
    }
}
